import {
  Component,
  OnInit,
  OnDestroy, Inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Subscription } from "rxjs";
import {LegacyRoutingService} from "../../core/services/legacy-routing/legacy-routing.service";
import {DOCUMENT} from "@angular/common";
import {FeatureFlagsService} from "../../core/services/feature-flag/feature-flags.service";

@Component({
  selector: 'sb-knockout-page',
  templateUrl: './knockout-page.component.html',
  styleUrls: ['./knockout-page.component.scss']
})
export class KnockoutPageComponent implements OnInit, OnDestroy {
  html: string;
  private urlSubscription: Subscription | null;
  private sammyRoutes: any;
  private priorNavigation: any = null;
  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private legacyRoutingService: LegacyRoutingService,
              private featureFlagsService: FeatureFlagsService,
              @Inject(DOCUMENT) private document) {
    this.urlSubscription = null;
    this.sammyRoutes = legacyRoutingService.get();

    $localize`:@@kop:kop`
  }

  // The odd handling of login is due to the fact that the server returns a 302 that is not a hash path
  // and the angular router does not see it.
  ngOnInit() {
    const that = this;
    if (!this.urlSubscription) {
      this.urlSubscription = this.activatedRoute.url.subscribe(
        (urlSegments) => {

          // PF: Some browsers emit a popstate event followed by a hashchange event when a navigation occurs. We want to
          // ignore the second one as that causes pages to be loaded twice in FireFox and Safari which can result
          // in list being displayed when detail is wanted due to a workaround already existing in
          // PageRendererImpl._renderPageContent. We have copied some code from the latest on master of Angular's
          // Router.scheduleNavigation .
          const isBrowserTriggeredNavigation = (source: 'imperative'|'popstate'|'hashchange') => {
            return source !== 'imperative';
          };

          const router = that.router as any;
          const currentNavigation = router.transitions.value;
          if (that.priorNavigation) {
            const browserNavPrecededByBrowserNav = isBrowserTriggeredNavigation(that.priorNavigation.source) && currentNavigation && isBrowserTriggeredNavigation(currentNavigation.source);
            const navToSameUrl = currentNavigation.rawUrl.toString() === that.priorNavigation.rawUrl.toString();
            const lastNavigationInProgress = currentNavigation.id === router.currentNavigation?.id;
            const isDuplicateNav = navToSameUrl && lastNavigationInProgress;
            that.priorNavigation = currentNavigation;
            if (browserNavPrecededByBrowserNav && isDuplicateNav) {
              return;
            }
          } else {
            that.priorNavigation = currentNavigation;
          }

          const handler = () => {
            if (that.sammyRoutes) {
              let context = {
                path: '/#' + that.router.routerState.snapshot.url,
                params: {
                  splat: [urlSegments.map((seg) => {
                    return seg.path
                  }).join("/")]
                }
              };
              if ((that.activatedRoute.queryParams as any).value.query) {
                (context.params as any).query = (that.activatedRoute.queryParams as any).value.query;
              }
              this.debug() && console.log("KnockoutPageComponent routing to", context);
              if (window.location.pathname.startsWith("/2FA")) {
                if (context.path === "/#/" || context.path === '/') {
                  this.debug() && console.log("KnockoutPageComponent: 2FA to Home");
                  window.location.href = "/";
                } else if (context.path.includes("/login")) {
                  this.debug() && console.log("KnockoutPageComponent: 2FA to login");
                  window.location.href = "/login";
                }
              } else if (context.path.includes("/login") || window.location.pathname.startsWith("/login")) {
                this.debug() && console.log("KnockoutPageComponent: login");
                context.path = "/login";
                that.sammyRoutes.loginRouteFunction(context);
              } else if (context.path.includes("/ForgotPassword") || window.location.pathname.startsWith("/ForgotPassword")) {
                this.debug() && console.log("KnockoutPageComponent: ForgotPassword");
                context.path = "/ForgotPassword";
                that.sammyRoutes.forgotPasswordRouteFunction(context);
              } else if (context.path.includes("/ResetPassword") || window.location.pathname.startsWith("/ResetPassword")) {
                this.debug() && console.log("KnockoutPageComponent: ResetPassword");
                context.path = "/ResetPassword";
                that.sammyRoutes.resetPasswordRouteFunction(context);
              } else if (context.path === "/" || context.path === "/#/") {
                this.debug() && console.log("KnockoutPageComponent: home");
                that.sammyRoutes.noopRouteFunction(context);
              } else if (context.path.includes("/logout")) {
                this.debug() && console.log("KnockoutPageComponent: logout");
                that.sammyRoutes.logoutRouteFunction(context);
              } else {
                this.debug() && console.log("KnockoutPageComponent: wildcard");
                that.sammyRoutes.wildcardRouteFunction(context);
              }
            } else {
              that.sammyRoutes = that.legacyRoutingService.get();
            }
          };

          handler();
        }
      );
    }
  }

  ngOnDestroy() {
    ( this.urlSubscription ) && this.urlSubscription.unsubscribe();
  }

  private debug(): boolean {
    return this.featureFlagsService.isOn("verbose-logging");
  }
}
